/* Trade Work Wear: explicit desktop mega-menu controls. */
(function () {
  'use strict';

  function closeMenus(except) {
    document.querySelectorAll('.tww-discovery-navigation .navigation__menuitem--active').forEach(function (item) {
      if (item !== except) {
        item.classList.remove('navigation__menuitem--active');
        var button = item.querySelector('.tww-menu-toggle');
        if (button) button.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function enhanceNavigation(nav) {
    nav.querySelectorAll('.navigation__menuitem--dropdown').forEach(function (item, index) {
      var panel = item.querySelector(':scope > .dropdown, :scope > .megamenu');
      var link = item.querySelector(':scope > .navigation__menulink');
      if (!panel || !link || item.querySelector('.tww-menu-toggle')) return;

      var panelId = panel.id || 'tww-menu-panel-' + index + '-' + Math.random().toString(36).slice(2, 7);
      panel.id = panelId;

      var button = document.createElement('button');
      button.className = 'tww-menu-toggle';
      button.type = 'button';
      button.setAttribute('aria-label', 'Show ' + link.textContent.trim() + ' menu');
      button.setAttribute('aria-controls', panelId);
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var opening = !item.classList.contains('navigation__menuitem--active');
        closeMenus(item);
        item.classList.toggle('navigation__menuitem--active', opening);
        button.setAttribute('aria-expanded', opening ? 'true' : 'false');
      });
      item.appendChild(button);

      // Desktop follows the established TCD pattern: moving onto a top-level
      // item opens its menu and moving away closes it. Touch devices keep the
      // explicit button so a tap never navigates away unexpectedly.
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        item.addEventListener('mouseenter', function () {
          closeMenus(item);
          item.classList.add('navigation__menuitem--active');
          button.setAttribute('aria-expanded', 'true');
        });
        item.addEventListener('mouseleave', function () {
          item.classList.remove('navigation__menuitem--active');
          button.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.tww-discovery-navigation').forEach(enhanceNavigation);
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.tww-discovery-navigation')) closeMenus();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenus();
    });
  });
}());
